"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _config = require("../../../../../../services/config");
var _googlePublisherTag = require("../../../../../../services/googlePublisherTag");
var _Collapsed = require("../../../../../ui/Collapsed");
var _selectors = require("../../store/selectors");
var _constants = require("../../constants");
var _styles = _interopRequireDefault(require("../../styles"));
var _SimilarHotels = require("../SimilarHotels");
var _BookingFormByOperator = require("../BookingFormByOperator");
var _check = _interopRequireDefault(require("./check.svg"));
var _styles2 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ROOT_SERVICES_BY_PRIORITY = ['location', 'hotel', 'room', 'beach', 'sport', 'child'];
var GOOGLE_PUBLISH_TAG_STYLE = {
  marginTop: '24px'
};
var maperWithIndex = R.addIndex(R.map);
var Description = function Description(_ref) {
  var description = _ref.description,
    hotelServicesDescription = _ref.hotelServicesDescription,
    servicesLabels = _ref.servicesLabels,
    queryID = _ref.queryID;
  var isShowBookingForOperatorForm = (0, _reactRedux.useSelector)(_selectors.getIsShowBookingForOperatorForm);
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var hotelServicesDescriptionList = (0, _react.useMemo)(function () {
    return hotelServicesDescription ? R.call(R.pipe(R.toPairs, R.sort(function (_ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 1),
        rootServiceA = _ref4[0];
      var _ref5 = _slicedToArray(_ref3, 1),
        rootServiceB = _ref5[0];
      return R.subtract(R.indexOf(rootServiceA, ROOT_SERVICES_BY_PRIORITY), R.indexOf(rootServiceB, ROOT_SERVICES_BY_PRIORITY));
    }), R.map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        rootService = _ref7[0],
        serviceGroup = _ref7[1];
      return {
        description: serviceGroup.description,
        services: R.call(R.pipe(R.toPairs, R.map(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            service = _ref9[0],
            status = _ref9[1];
          return {
            name: servicesLabels[service],
            status: status
          };
        }), R.filter(R.prop('name'))), serviceGroup.services),
        title: servicesLabels[rootService]
      };
    }), R.filter(function (_ref0) {
      var services = _ref0.services,
        ownDescription = _ref0.description;
      return ownDescription || services.length;
    })), hotelServicesDescription) : [];
  }, [hotelServicesDescription, servicesLabels]);
  var googlePublishTag = (0, _config.getGooglePublishTagForOfferDetails)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.root,
    id: _constants.DESCRIPTION_ID
  }, isShowBookingForOperatorForm && /*#__PURE__*/_react.default.createElement(_BookingFormByOperator.BookingForm, {
    queryID: queryID
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.mobileTitle
  }, t('HOTEL_DESCRIPTION_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.description,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), (0, _config.getOnGetSimilarHotels)() && /*#__PURE__*/_react.default.createElement(_SimilarHotels.SimilarHotels, {
    queryID: queryID
  }), googlePublishTag && /*#__PURE__*/_react.default.createElement(_googlePublisherTag.GooglePublisherTagWrapper, {
    adPath: googlePublishTag.adPath,
    id: googlePublishTag.id,
    sizeMapping: googlePublishTag.sizeMapping,
    style: GOOGLE_PUBLISH_TAG_STYLE
  }), /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    initialOpen: true,
    title: t('COLLAPSED_HOTEL_DESCRIPTION'),
    className: _styles2.default.collapsed,
    contentClassName: _styles2.default.collapsedContent
  }, maperWithIndex(function (_ref1, index) {
    var title = _ref1.title,
      ownDescription = _ref1.description,
      services = _ref1.services;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.block,
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.title
    }, title), ownDescription && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.text,
      dangerouslySetInnerHTML: {
        __html: ownDescription
      }
    }), Boolean(services.length) && /*#__PURE__*/_react.default.createElement("ul", null, R.map(function (_ref10) {
      var name = _ref10.name,
        status = _ref10.status;
      return /*#__PURE__*/_react.default.createElement("li", {
        "data-type": status,
        key: name
      }, /*#__PURE__*/_react.default.createElement("i", {
        dangerouslySetInnerHTML: {
          __html: _check.default
        }
      }), name, ' ', /*#__PURE__*/_react.default.createElement("span", null));
    }, services)));
  }, hotelServicesDescriptionList)));
};
Description.T = {
  description: _propTypes.default.string,
  hotelServicesDescription: _propTypes.default.object,
  queryID: _propTypes.default.string,
  servicesLabels: _propTypes.default.object
};
var _default = exports.default = (0, _react.memo)(Description);